'use client'

import * as React from 'react'
import Image, { type ImageProps } from 'next/image'

// next/image wrapper that survives a dead source. Several demo galleries
// seed tiles from Unsplash photo IDs, and Unsplash deactivates photos over
// time, leaving broken image boxes. On error we swap to a deterministic
// Lorem Picsum photo (seeded by the original src, so it stays stable) — a
// real image always loads instead of a broken tile.
export function SafeImage({ src, fallbackSeed, ...rest }: ImageProps & { fallbackSeed?: string | number }) {
  const seed = encodeURIComponent(String(fallbackSeed ?? src))
  const fallback = `https://picsum.photos/seed/${seed}/600/750`
  const [current, setCurrent] = React.useState<ImageProps['src']>(src)
  return <Image {...rest} src={current} onError={() => current !== fallback && setCurrent(fallback)} />
}
